import TrafficSource from '../../../containers/TrafficSource';

const TrafficSourceRoutes = [
  {
    path: '/user/traffic_source',
    exact: true,
    component: TrafficSource,
  },
];

export default TrafficSourceRoutes;
